<template>
  <div class="d-inline-block mr-3 mb-2 align-top">
    <v-tooltip bottom :disabled="!showReason">
      <template v-slot:activator="{ on }">
        <span v-on="on">
          <v-btn
            small
            :color="color"
            :outlined="outlined"
            :disabled="state.disabled || busy"
            :loading="loading"
            @click="$emit('click')"
          >
            <slot>{{ label }}</slot>
          </v-btn>
        </span>
      </template>
      <span>{{ state.reason }}</span>
    </v-tooltip>
    <div v-if="showReason" class="caption grey--text text--darken-1 mt-1" style="max-width: 280px">
      {{ state.reason }}
    </div>
  </div>
</template>

<script>
import { stepButton } from "@/utils/cvcMigrationPage";

// One action button. It is on only when the server says so (`steps[name]`),
// and when it is off the server's reason shows as a tooltip and as small text
// under the button. `busy` (another action of this tab is running) disables it
// without a reason; `loading` marks the one that was clicked.
export default {
  name: "StepButton",
  props: {
    steps: { type: Object, default: null },
    name: { type: String, default: "" },
    // Use instead of steps/name when the rule is not one server flag: { disabled, reason }.
    override: { type: Object, default: null },
    label: { type: String, default: "" },
    color: { type: String, default: "primary" },
    outlined: { type: Boolean, default: false },
    busy: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
  },
  computed: {
    state () {
      return this.override || stepButton(this.steps, this.name);
    },
    showReason () {
      return this.state.disabled && !!this.state.reason;
    },
  },
};
</script>
